import { ActionPanel } from "../actionPanel/ActionPanel";

export const SellarCreditOrderNotPaid = ({
  buyerVenueName,
}: {
  buyerVenueName: string;
}) => {
  return (
    <ActionPanel
      className="flex flex-col gap-4"
      title="Customer payment incomplete"
    >
      <div className="flex flex-col gap-4">
        <p>{`You cannot finalise this order yet. ${buyerVenueName} must complete their request to pay using Sellar Credit.`}</p>
      </div>
    </ActionPanel>
  );
};
